import Component from 'flarum/common/Component';

import MapSearchComponent from "./MapSearchComponent";
import StatisticSidebarComponent from "./StatisticSidebarComponent";
import AnnouncementSidebarComponent from "./AnnouncementSidebarComponent";
import InfoSidebarUserType0Component from "./InfoSidebarUserType0Component";
import InfoSidebarUserType9Component from "./InfoSidebarUserType9Component";
import QuerySidebarComponent from "./QuerySidebarComponent";
import DistributeSidebarComponent from "./DistributeSidebarComponent";
import UserManageSidebarComponent from "./UserManageSidebarComponent";
import bindAutoLoad from "../common/util/bindAutoLoad";
import LogoComponent from "./LogoComponent";
import UserSubmitComponent from "./UserSubmitComponent";

export default class SidebarComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.mapModule = this.attrs.mapModule;
    this.mapModuleSideBarID = this.attrs.mapModuleID+"SideBar";
    this.mapModuleSwipeAreaID = this.attrs.mapModuleID+"SwipeArea";
    this.mapModuleSwipeAreaMaskID = this.attrs.mapModuleID+"SwipeAreaMask";
    this.mapInfoDataList = this.attrs.mapInfoDataList || [];
    this.mapSidebarMobileState = "min";
    this.selectedCategory = this.attrs.selectedCategory;

    this.touchstartY = 0;
    this.touchendY = 0;
  }

  onupdate(){
    if(this.selectedCategory!==this.attrs.selectedCategory){
      this.selectedCategory = this.attrs.selectedCategory;
      m.redraw();
    }
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    this.initListeners();

    bindAutoLoad("#indexPageMapSideBar");
  }

  initListeners() {
    const _this = this;

    $("#"+this.mapModuleSwipeAreaID).on('touchstart', e => {
      _this.touchstartY = e.changedTouches[0].screenY;
      $(".amap-maps").css("pointer-events","none");
    })

    $("#"+this.mapModuleSwipeAreaID).on('touchend', e => {
      _this.touchendY = e.changedTouches[0].screenY;
      $(".amap-maps").css("pointer-events","");

      if(_this.touchendY<_this.touchstartY){
        //up
        let mapSidebarMobileState = this.mapSidebarMobileState;
        let mapSidebarHeight = "200px";
        
        if(this.mapSidebarMobileState==="min"){
          mapSidebarMobileState = "max";
          mapSidebarHeight = "80vh";

          $(".u2diMapSideBarMobileSliderArea").hide();
          $(".u2diMapSideBarMobileContentArea").show();
        }
        
        // else if(this.mapSidebarMobileState==="min"){
        //   mapSidebarMobileState = "normal";
        //   mapSidebarHeight = "200px"

        //   $(".u2diMapSideBarMobileSliderArea").show();
        //   $(".u2diMapSideBarMobileContentArea").hide();
        // }

        if(this.mapSidebarMobileState!==mapSidebarMobileState){
          this.mapSidebarMobileState = mapSidebarMobileState;

          $(".u2diMapSideBarMobile").animate({
            height: mapSidebarHeight
          }, 330);
        }
      }

      if(_this.touchendY>_this.touchstartY){
        //down
        let mapSidebarMobileState = this.mapSidebarMobileState;
        let mapSidebarHeight = "200px";

        // if(this.mapSidebarMobileState==="max"){
        //   mapSidebarMobileState = "normal";
        //   mapSidebarHeight = "200px"

        //   $(".u2diMapSideBarMobileSliderArea").show();
        //   $(".u2diMapSideBarMobileContentArea").hide();
        // }else 
        
        if(this.mapSidebarMobileState==="max"){
          mapSidebarMobileState = "min";
          mapSidebarHeight = "80px"

          $(".u2diMapSideBarMobileSliderArea").hide();
          $(".u2diMapSideBarMobileContentArea").hide();
        }

        if(this.mapSidebarMobileState!==mapSidebarMobileState){
          this.mapSidebarMobileState = mapSidebarMobileState;

          $(".u2diMapSideBarMobile").animate({
            height: mapSidebarHeight
          }, 330);
        }

      }
    })
  }

  view() {
    const mapModule = this.mapModule;
    const mapInfoDataList = this.mapInfoDataList;
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const mapHeight = document.documentElement.clientHeight+"px";

    return (
      <div>
        <div style={"height:"+mapHeight+";"} className="u2diMapSideBarContainer">
          <div id={this.mapModuleSideBarID} className="u2diMapSideBar">
            {this.selectedCategory==="tj" && (
              <StatisticSidebarComponent viewType="normal" />
            )}

            {this.selectedCategory==="gg" && (
              <AnnouncementSidebarComponent viewType="normal" />
            )}

            {this.selectedCategory==="td" && u2diUserType9===true && (
              <InfoSidebarUserType9Component viewType="normal" />
            )}

            {this.selectedCategory==="td" && u2diUserType0===true && u2diUserType9===false && (
              <InfoSidebarUserType0Component viewType="normal" />
            )}

            {this.selectedCategory==="xd" && (
              <QuerySidebarComponent viewType="normal" />
            )}

            {this.selectedCategory==="fx" && (
              <DistributeSidebarComponent viewType="normal" />
            )}

            {this.selectedCategory==="yh" && (
              <UserManageSidebarComponent viewType="normal" />
            )}
          </div>
        </div>

        <div className="u2diMapSideBarMobileContainer">
          <div className="u2diLogoMobileArea">
            {LogoComponent.component()}
          </div>
          <div className="u2diMapMobileSubmitArea">
            {UserSubmitComponent.component()}
          </div>
          <div id={this.mapModuleSwipeAreaMaskID} className="u2diMapSideBarMobileMask"></div>
          <div className="u2diMapSideBarMobile">
              <div id={this.mapModuleSwipeAreaID}>
                <div className="u2diMapSideBarMobileSwipeArea">
                  <hr className="u2diMapSideBarMobileSwipeLine" />
                </div>
                <div className="u2diMapMobileSearchArea">
                  {MapSearchComponent.component({mapModule,mapInfoDataList})}
                </div>
              </div>

              {this.selectedCategory==="gg" && (
                <AnnouncementSidebarComponent viewType="mobile" />
              )}
              
              {this.selectedCategory==="td" && u2diUserType9===true && (
                <InfoSidebarUserType9Component viewType="mobile" />
              )}

              {this.selectedCategory==="td" && u2diUserType0===true && u2diUserType9===false && (
                <InfoSidebarUserType0Component viewType="mobile" />
              )}

              {this.selectedCategory==="xd" && (
                <QuerySidebarComponent viewType="mobile" />
              )}

              {this.selectedCategory==="fx" && (
                <DistributeSidebarComponent viewType="mobile" />
              )}

              {this.selectedCategory==="yh" && (
                <UserManageSidebarComponent viewType="mobile" />
              )}
          </div>
        </div>
      </div>
    );
  }

}